<template>
  <div class="w-100">
    <div class="row">
      <div class="z-form z-card border-0">
        <z-form ref="form">
          <base-form :campaign="campaign" :disabled="true" @input="set_data" />
        </z-form>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <i-button :loading="loading" type="primary" size="large" @click="send">
          {{ $t('autocaller_v2.campaign.form.save_btn') }}
        </i-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  import BaseForm from '@autocaller_v2/components/campaigns-base-form';
  export default {
    components: { BaseForm },
    props: {
      id: {
        type: [Number, String],
        default: null
      },
      item: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      loading: false,
      form: {},
      campaign: {},
      is_loading: true
    }),

    watch: {
      item: {
        handler: function (item) {
          this.campaign = item;
        },
        immediate: true
      }
    },
    methods: {
      set_data(data) {
        this.form = data;
      },
      send() {
        this.$refs.form.validate().then((is_valid) => {
          this.form.active_switch ? (this.form.active = 1) : (this.form.active = 0);
          this.form.record_calls_switch
            ? (this.form.record_calls = 1)
            : (this.form.record_calls = 0);
          !this.form.asr_reset
            ? (this.form.bounce_duration_threshold = 0)
            : this.form.bounce_duration_threshold;
          this.form.strategy = this.form.strategy.map((val) => (val === null ? (val = 1) : val));
          this.form.order_rules.forEach((item, i) => (item.priority = i + 1));
          if (is_valid) {
            this.loading = true;
            const fields = this.form;
            const data = { ...fields };

            CampaignsService.editItem(this.campaign.id, data)
              .then(() => {
                this.$router.push({ name: 'autocaller_v2.campaign.index' });
              })
              .catch((error) => {
                this.$noty.server_error(error);
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
      }
    }
  };
</script>
